import { render, staticRenderFns } from "./CollectionSearch.vue?vue&type=template&id=e9cfc730&scoped=true"
import script from "./CollectionSearch.vue?vue&type=script&lang=js"
export * from "./CollectionSearch.vue?vue&type=script&lang=js"
import style0 from "./CollectionSearch.vue?vue&type=style&index=0&id=e9cfc730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9cfc730",
  null
  
)

export default component.exports